









































import Vue from 'vue';
import { mapActions } from 'vuex';
import LoadingSpinner from '@reciprocity/loading-spinner';

import ZenTable from '@/components/listing/ZenTable.vue';
import FinalizeButton from './components/FinalizeButton';
import HeaderInfo from './components/HeaderInfo';
import CoveragePresenter from './components/CoveragePresenter';
import ScopedChildPresenter from './components/ScopedChildPresenter';
import {
  calculateScopedCounts,
  calculateCoveredObjectiveCount,
  calculateCoveredObjectiveFinalCount,
  determineProgramStage,
  getScopedObjectiveIds,
} from './programHelpers';

export default Vue.extend({
  name: 'ProgramScopingPage',
  components: {
    CoveragePresenter,
    FinalizeButton,
    HeaderInfo,
    LoadingSpinner,
    ScopedChildPresenter,
    ZenTable,
  },
  data() {
    return {
      columns: [
        { key: 'title', presenter: 'Title' },
        { key: 'status', presenter: 'Status' },
        'standards',
        'sections',
        'objectives',
        'controls',
        'coverage',
        'actions',
      ],
      filterFinalized: true,
    };
  },
  computed: {
    loading(): boolean {
      return this.$apollo.loading;
    },
  },
  created() {
    this.setPageTitle({ title: 'Programs' });
    // TODO: This can be removed once the universal mapper switches to GQL.
    this.$apollo.queries.programs.refetch();
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
    }),
  },
  apollo: {
    programs: {
      query: require('./queries/ProgramList.gql'),
      update: data => {
        data.search.edges = data.search.edges.sort((a, b) => {
          if (a.node.title.value === 'Secure Controls Framework') return 1;
          if (a.node.status.value === 'Final' && b.node.status.value !== 'Final') return -1;
          return 0;
        });
        return data.search.edges
          .map(e => e.node)
          .map(n => ({ ...n, scopedCounts: calculateScopedCounts(n) }))
          .map(n => ({ ...n, stage: determineProgramStage(n) }))
          .map(n => ({ ...n, coveredObjectiveCount: calculateCoveredObjectiveCount(n) }))
          .map(n => ({ ...n, coveredObjectiveFinalCount: calculateCoveredObjectiveFinalCount(n) }))
          .map(n => ({ ...n, scopedObjectiveIds: getScopedObjectiveIds(n) }));
      },
    },
  },
});
